export function computeCutPoints(values: number[], quantiles = 5): number[] {
    const sorted = values.filter(v => Number.isFinite(v)).sort((a, b) => a - b);
    if (sorted.length === 0) return [];
    const cuts: number[] = [];
    for (let i = 1; i < quantiles; i++) {
        let rank = Math.ceil((i * sorted.length) / quantiles) - 1;
        if (rank < 0) rank = 0;
        if (rank >= sorted.length) rank = sorted.length - 1;
        cuts.push(sorted[rank]);
    }
    return cuts;
}

export function getQuantile(value: number, cuts: number[]): number {
    let bucket = 1;
    for (const cut of cuts) {
        if (value <= cut) return bucket;
        bucket++;
    }
    return bucket;
}
